import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePushNotifications } from "../../hooks/usePushNotifications";

import OpenJobs from "./Components/OpenJobs/OpenJobs";
import Applications from "./Components/MyApplications/MyApplications";
import InProgress from "../../Components/SharedInProgress/InProgress";
import CompletedJobs from "../DashboardFreelancer/Components/CompletedJobs/CompletedJobs";
import Agenda from "./Components/Freelanceragenda/Freelanceragenda";
import Training from "./Components/Training";
import InvitedJobs from "../DashboardFreelancer/Components/InviteJobs/InviteJobs";
import GoldWidget from "../../Components/GoldWidget/GoldWidget";
import GoldModal from "../../Components/GoldSubscriptionModal/GoldSubscriptionModal"
import NotificationBell from "../../Components/Notificationbell/Notificationbell";
import WalletModal from "../../Components/WalletModal/WalletModal"


//modal de notificações
import GoldOnboardingModal from "../../Components/GoldOnboardingModal/GoldOnboardingModal"

import {
    Play,
    Wallet,
    HandCoins,
    UserCog,
    LayoutDashboard,
    Briefcase,
    FileCheck,
    Clock,
    CheckCircle,
    Calendar,
    GraduationCap,
    Bell,
    Menu,
    X,
    User,
    Star,
    MapPin,
    CalendarDays,
    Crown,
    BellRing
} from "lucide-react";
import "./DashboardFreelancer.scss";

import ProfileModal from "../../Components/FreelancerProfileModal/FreelancerProfileModal";
import { getMe, updateProfile, updateAvatar } from "../../services/authService";
import { getMyInvites } from "../../services/applicationService";
import { getWallet } from "../../services/walletService";
import ChatSupportButton from "../../Components/ChatSupportButton/ChatSupportButton";
import DocumentStatusAlert from "../../Components/DocumentStatusAlert/DocumentStatusAlert";
import InstallPwaBanner from "../../Components/InstallPwaBanner/InstallPwaBanner";
import NotificationSettings from "../../Components/NotificationSettings/NotificationSettings";
import { getInitialTab } from "../../utils/dashboardTab";

// ─── Helper de CEP (mesmo padrão do FreelancerProfileModal) ────────────
function formatarCEP(value) {
    return value.replace(/\D/g, '').slice(0, 8).replace(/(\d{5})(\d{1,3})/, '$1-$2');
}

const FREELANCER_TABS = ["vagas", "convites", "candidaturas", "andamento", "finalizadas", "agenda", "treinamento", "notificacoes"];

export default function DashboardFreelancer() {
    const navigate = useNavigate();
    // ?tab=... vem dos links das notificações (push e e-mail)
    const [activeTab, setActiveTab] = useState(() => getInitialTab(FREELANCER_TABS, "vagas"));
    const [user, setUser] = useState(null);
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [invitesCount, setInvitesCount] = useState(0);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [showWalletModal, setShowWalletModal] = useState(false);
    const [wallet, setWallet] = useState(null);
    const isGold = user?.currentPlan?.toLowerCase().includes("gold");
    const isPremium = user?.currentPlan?.toLowerCase().includes("premium");
    const isPlus = user?.currentPlan?.toLowerCase().includes("plus");
    const isFreePlan = !isGold && !isPremium && !isPlus;
    const [isGoldModalOpen, setIsGoldModalOpen] = useState(false);
    const hasImmediateJobAccess = isGold || isPremium || isPlus;
    const { isSupported } = usePushNotifications();
    // No início do componente, substitua:
    const [showGoldOnboarding, setShowGoldOnboarding] = useState(false); // ⬅️ Começa como false

    // ─── Estado do aviso/formulário inline de CEP ──────────────────────
    const [showCepForm, setShowCepForm] = useState(false);
    const [loadingCep, setLoadingCep] = useState(false);
    const [savingCep, setSavingCep] = useState(false);
    const [cepForm, setCepForm] = useState({
        cep: '', logradouro: '', bairro: '', cidade: '', estado: '',
        numero: '', complemento: '', lat: undefined, lng: undefined,
    });

    const userCep = user?.address?.cep || user?.cep || '';
    const hasValidCep = userCep.replace(/\D/g, '').length === 8;

    // E adicione um useEffect para controlar quando mostrar:
    useEffect(() => {
        // Verifica se é Freelancer FREE e se já viu o modal
        const userData = JSON.parse(localStorage.getItem("user") || "{}");
        const alreadySeen = localStorage.getItem("gold_onboarding_seen") === "true";

        // Verifica se é Free (não Gold, Premium ou Plus)
        const isFree = userData?.userType === "Freelancer" &&
            !userData?.currentPlan?.toLowerCase().includes("gold") &&
            !userData?.currentPlan?.toLowerCase().includes("premium") &&
            !userData?.currentPlan?.toLowerCase().includes("plus");

        // Mostra apenas se for Free e nunca viu
        if (isFree && !alreadySeen) {
            setShowGoldOnboarding(true);
            // Marca que já viu
            localStorage.setItem("gold_onboarding_seen", "true");
        }
    }, []); // Roda uma vez ao montar

    const PLAN_LABELS = {
        GoldTrial: "Gold",
        Gold1Month: "Gold",
        Gold3Months: "Gold",
        Gold6Months: "Gold",
        Gold12Months: "Gold",
        Plus: "Plus",
        Premium: "Premium"
    };

    const formatCurrency = (value) => {
        return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        }).format(Number(value) || 0);
    };

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            if (!mobile) {
                setIsSidebarOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const loadUser = async () => {
            try {
                const userId = localStorage.getItem("userId");
                const data = await getMe(userId);
                setUser(data);
            } catch (error) {
                console.error(error);
            }
        };

        loadUser();
    }, []);

    useEffect(() => {
        const loadInvitesCount = async () => {
            try {
                const invites = await getMyInvites();
                setInvitesCount(invites.length);
            } catch (error) {
                console.error(error);
            }
        };

        loadInvitesCount();
    }, [activeTab]);

    useEffect(() => {
        loadWallet();
    }, []);

    async function loadWallet() {
        try {
            const data = await getWallet();
            setWallet(data);
        } catch (err) {
            console.error(err);
        }
    }

    // ─── Autobusca de CEP (mesmo padrão do FreelancerProfileModal) ─────
    const buscarCepFreelancer = async (cep) => {
        const cepLimpo = cep.replace(/\D/g, '');
        if (cepLimpo.length !== 8) return;

        setLoadingCep(true);

        try {
            const response = await fetch(`https://brasilapi.com.br/api/cep/v2/${cepLimpo}`);

            if (!response.ok) {
                alert("CEP não encontrado.");
                return;
            }

            const data = await response.json();
            const lat = data.location?.coordinates?.latitude;
            const lng = data.location?.coordinates?.longitude;

            setCepForm(prev => ({
                ...prev,
                cep: data.cep || cepLimpo,
                logradouro: data.street || '',
                bairro: data.neighborhood || '',
                cidade: data.city || '',
                estado: data.state || '',
                lat: lat != null ? Number(lat) : prev.lat,
                lng: lng != null ? Number(lng) : prev.lng,
            }));
            // Se a BrasilAPI não retornar coordenadas, o backend deve geocodificar
            // a partir do endereço textual ao salvar (mesma regra já usada no perfil).
        } catch (error) {
            console.error("Erro ao buscar CEP:", error);
            alert("Não foi possível buscar o CEP agora. Tente novamente.");
        } finally {
            setLoadingCep(false);
        }
    };

    // ─── Salva o CEP sem sair do feed, reaproveitando handleUpdateProfile ──
    const handleSaveCep = async () => {
        const cepLimpo = cepForm.cep.replace(/\D/g, '');

        if (cepLimpo.length !== 8) {
            alert("Informe um CEP válido.");
            return;
        }

        if (!cepForm.numero) {
            alert("Informe o número do endereço.");
            return;
        }

        setSavingCep(true);

        try {
            // Payload completo, baseado no user atual — evita zerar outros campos do perfil
            const payload = {
                name: user.name,
                phone: user.phone,
                cpf: user.cpf,
                cnpj: user.cnpj,
                avatarUrl: user.avatarUrl,
                gender: user.gender,
                nomeSocial: user.nomeSocial,
                searchRadius: user.searchRadius,
                bio: user.bio,
                lat: cepForm.lat ?? user.lat ?? null,
                lng: cepForm.lng ?? user.lng ?? null,
                documentType: user.documentType,
                documentUrlFront: user.documentUrlFront,
                documentUrlBack: user.documentUrlBack,
                documentStatus: user.documentStatus,
                areas: user.areas,
                workExperiences: user.workExperiences,
                address: {
                    cep: cepLimpo,
                    logradouro: cepForm.logradouro,
                    numero: cepForm.numero,
                    complemento: cepForm.complemento || null,
                    bairro: cepForm.bairro,
                    cidade: cepForm.cidade,
                    estado: cepForm.estado,
                },
            };

            const result = await handleUpdateProfile(payload);

            if (result?.success) {
                setShowCepForm(false);
                setCepForm({ cep: '', logradouro: '', bairro: '', cidade: '', estado: '', numero: '', complemento: '', lat: undefined, lng: undefined });
            } else {
                alert(result?.message || "Erro ao salvar CEP.");
            }
        } finally {
            setSavingCep(false);
        }
    };

    const tabs = [
        { id: "vagas", label: "Vagas Abertas", icon: Briefcase },
        { id: "candidaturas", label: "Minhas Candidaturas", icon: FileCheck },
        { id: "andamento", label: "Em Andamento", icon: Clock },
        { id: "finalizadas", label: "Finalizadas", icon: CheckCircle },
        { id: "agenda", label: "Minha Agenda", icon: Calendar },
        { id: "notificacoes", label: "Notificações", icon: BellRing },
    ];

    const mobileMenuItems = [
        { id: "vagas", label: "Vagas Abertas", icon: Briefcase },
        { id: "candidaturas", label: "Minhas Candidaturas", icon: FileCheck },
        { id: "andamento", label: "Em Andamento", icon: Clock },
        { id: "finalizadas", label: "Finalizadas", icon: CheckCircle },
        { id: "agenda", label: "Minha Agenda", icon: Calendar },
        { id: "convites", label: "Convites", icon: Bell, badge: invitesCount },
        { id: "treinamento", label: "Treinamento", icon: GraduationCap },
        { id: "notificacoes", label: "Notificações", icon: BellRing },
    ];

    const renderContent = () => {
        switch (activeTab) {
            case "vagas":
                return <OpenJobs onViewFinished={() => setActiveTab("finalizadas")} isFreePlan={isFreePlan} />;
            case "convites":
                return <InvitedJobs onInviteHandled={() => setInvitesCount(c => Math.max(0, c - 1))} />;
            case "candidaturas":
                return <Applications onViewFinished={() => setActiveTab("finalizadas")} />;
            case "andamento":
                return <InProgress />;
            case "finalizadas":
                return <CompletedJobs />;
            case "agenda":
                return <Agenda onViewDetails={() => setActiveTab("andamento")} />;
            case "treinamento":
                return <Training />;
            case "notificacoes":
                return <NotificationSettings userType="freelancer" />;
            default:
                return <OpenJobs />;
        }
    };

    // ─── HANDLE UPDATE PROFILE ──────────────────────────────────────────
    const handleUpdateProfile = async (formData) => {
        try {
            const updatedUser = await updateProfile(user.id, formData);
            setUser(updatedUser);
            localStorage.setItem("user", JSON.stringify(updatedUser));
            return {
                success: true,
                message: "Perfil atualizado com sucesso!"
            };
        } catch (error) {
            return {
                success: false,
                message: error?.response?.data || "Erro ao atualizar perfil"
            };
        }
    };

    // ─── HANDLE AVATAR UPDATE ────────────────────────────────────────────
    const handleAvatarUpdate = async (newAvatarUrl) => {
        try {
            setUser(prev => ({
                ...prev,
                avatarUrl: newAvatarUrl
            }));

            const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
            localStorage.setItem('user', JSON.stringify({
                ...storedUser,
                avatarUrl: newAvatarUrl
            }));

            return {
                success: true,
                message: "Avatar atualizado com sucesso!"
            };
        } catch (error) {
            console.error("Erro ao atualizar avatar:", error);
            return {
                success: false,
                message: "Erro ao atualizar avatar"
            };
        }
    };

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        if (isMobile) {
            setIsSidebarOpen(false);
        }
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className="dashboard">
            {/* ========== VERSÃO DESKTOP (só renderiza se NÃO for mobile) ========== */}
            {!isMobile && (
                <div className="dashboard-desktop">
                    {/* Header Desktop */}
                    <header className="dashboard-header">
                        <div className="dashboard-header__left">
                            <div className="dashboard-header__profile">
                                <div className="dashboard-header__avatar-wrapper">
                                    <img
                                        src={user?.avatarUrl || "https://ui-avatars.com/api/?name=Usuario&background=1ec88a&color=fff&size=128"}
                                        alt="Perfil"
                                        className="dashboard-header__avatar"
                                    />
                                    <span className="dashboard-header__status-indicator" />
                                </div>

                                <div className="dashboard-header__user-info">
                                    <h1 className="dashboard-header__greeting">
                                        Olá, {user?.name || "Usuário"}
                                    </h1>
                                    <div className="dashboard-header__user-meta">
                                        <button
                                            type="button"
                                            className="dashboard-header__role"
                                            onClick={() => navigate("/painel-profissional")}
                                        >
                                            <LayoutDashboard size={14} />
                                            Painel do Profissional
                                        </button>
                                        {/* 🔥 SEMPRE UM BOTÃO CLICÁVEL */}
                                        <button
                                            type="button"
                                            className={`dashboard-mobile__plan-badge ${user?.isGold ? 'dashboard-mobile__plan-badge--gold' : 'dashboard-mobile__plan-badge--free'}`}
                                            onClick={() => setIsGoldModalOpen(true)}
                                        >
                                            {user?.isGold && <Crown size={14} fill="currentColor" />}
                                            {user?.isGold ? 'Gold' : (PLAN_LABELS[user?.currentPlan] ?? user?.currentPlan ?? 'Free')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="dashboard-header__actions">
                            <div
                                className="dashboard-sidebar__info-item dashboard-sidebar__info-item--wallet"
                                onClick={() => setShowWalletModal(true)}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) =>
                                    e.key === 'Enter' && setShowWalletModal(true)
                                }
                            >
                                <div className="dashboard-sidebar__wallet-icon">
                                    <Wallet size={16} strokeWidth={2} />
                                </div>

                                <div className="dashboard-sidebar__wallet-content">
                                    <span className="dashboard-sidebar__wallet-label">
                                        Saldo disponível
                                    </span>

                                    <strong className="dashboard-sidebar__wallet-value">
                                        {formatCurrency(
                                            (wallet?.balance ?? 0) - (wallet?.reserved ?? 0)
                                        )}
                                    </strong>
                                </div>
                            </div>

                            <button
                                className="dashboard-header__action-btn dashboard-header__action-btn--profile"
                                onClick={() => setShowProfileModal(true)}
                            >
                                <UserCog size={18} />
                                <span className="dashboard-header__action-label">Configurações</span>
                            </button>

                            <button
                                className="dashboard-header__action-btn dashboard-header__action-btn--invites"
                                onClick={() => handleTabClick("convites")}
                            >
                                <Bell size={18} />
                                <span className="dashboard-header__action-label">Convites</span>
                                {invitesCount > 0 && (
                                    <span className="dashboard-header__action-badge">{invitesCount}</span>
                                )}
                            </button>

                            <NotificationBell />
                        </div>
                    </header>

                    {/* Tabs Desktop */}
                    <nav className="dashboard-nav">
                        <div className="dashboard-nav__tabs">
                            {tabs.map((tab) => {
                                const Icon = tab.icon;
                                const isActive = activeTab === tab.id;
                                return (
                                    <button
                                        key={tab.id}
                                        className={`dashboard-nav__tab ${isActive ? 'dashboard-nav__tab--active' : ''}`}
                                        onClick={() => handleTabClick(tab.id)}
                                    >
                                        <Icon size={18} />
                                        <span className="dashboard-nav__tab-label">{tab.label}</span>
                                    </button>
                                );
                            })}
                        </div>

                        <button
                            className={`dashboard-nav__training-btn ${activeTab === "treinamento" ? 'dashboard-nav__training-btn--active' : ''}`}
                            onClick={() => handleTabClick("treinamento")}
                        >
                            <Play size={16} />
                            <span>Treinamento</span>
                            <span className="dashboard-nav__training-icon">✨</span>
                        </button>
                    </nav>
                </div>
            )}

            {/* ========== VERSÃO MOBILE (só renderiza se FOR mobile) ========== */}
            {isMobile && (
                <div className="dashboard-mobile">
                    {/* Header Mobile */}
                    <header className="dashboard-mobile__header">
                        <button
                            className="dashboard-mobile__menu-btn"
                            onClick={toggleSidebar}
                            aria-label="Abrir menu"
                        >
                            <Menu size={24} />
                            {!isSidebarOpen && (
                                <span className="dashboard-mobile__glow" />
                            )}
                        </button>

                        <div className="dashboard-mobile__user">
                            <img
                                src={user?.avatarUrl || "https://ui-avatars.com/api/?name=Usuario&background=1ec88a&color=fff&size=128"}
                                alt="Perfil"
                                className="dashboard-mobile__avatar"
                            />
                            <div>
                                <span className="dashboard-mobile__name">{user?.name || "Usuário"}</span>
                                <div className="dashboard-header__user-meta">
                                    <button
                                        type="button"
                                        className="dashboard-header__role"
                                        onClick={() => navigate("/painel-profissional")}
                                    >
                                        <LayoutDashboard size={14} />
                                        Painel do Profissional
                                    </button>
                                    {/* 🔥 SEMPRE UM BOTÃO CLICÁVEL */}
                                    <button
                                        type="button"
                                        className={`dashboard-mobile__plan-badge ${user?.isGold ? 'dashboard-mobile__plan-badge--gold' : 'dashboard-mobile__plan-badge--free'}`}
                                        onClick={() => setIsGoldModalOpen(true)}
                                    >
                                        {user?.isGold && <Crown size={14} fill="currentColor" />}
                                        {user?.isGold ? 'Gold' : (PLAN_LABELS[user?.currentPlan] ?? user?.currentPlan ?? 'Free')}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* 🔥 BOTÕES DO HEADER MOBILE - Configurações e Notificações */}
                        <div className="dashboard-mobile__header-actions">
                            <NotificationBell />
                        </div>
                    </header>

                    {/* ── Banner de instalação — fora da sidebar, logo abaixo do header ── */}
                    <InstallPwaBanner />

                    {/* Sidebar Mobile */}
                    <aside className={`dashboard-sidebar ${isSidebarOpen ? 'dashboard-sidebar--open' : ''}`}>
                        <div className="dashboard-sidebar__header">
                            <div className="dashboard-sidebar__profile">
                                <div className="dashboard-sidebar__avatar-wrapper">
                                    <img
                                        src={user?.avatarUrl || "https://ui-avatars.com/api/?name=Usuario&background=1ec88a&color=fff&size=128"}
                                        alt="Perfil"
                                        className="dashboard-sidebar__avatar"
                                    />
                                    <span className="dashboard-sidebar__status" />
                                </div>

                                <div className="dashboard-sidebar__user-info">
                                    <h2 className="dashboard-sidebar__name">
                                        {user?.name || "Usuário"}
                                    </h2>
                                    <button
                                        type="button"
                                        className="dashboard-header__role"
                                        onClick={() => navigate("/painel-profissional")}
                                    >
                                        <LayoutDashboard size={14} />
                                        Painel do Profissional
                                    </button>
                                    <div className="dashboard-sidebar__rating">
                                        <Star size={14} />
                                        <span>{user?.rating || "Sem avaliações"}</span>
                                    </div>
                                </div>
                            </div>

                            <button
                                className="dashboard-sidebar__close"
                                onClick={toggleSidebar}
                                aria-label="Fechar menu"
                            >
                                <X size={24} />
                            </button>
                        </div>

                        <div className="dashboard-sidebar__quick-info">
                            <div
                                className="dashboard-sidebar__info-item dashboard-sidebar__info-item--clickable"
                                onClick={() => {
                                    setShowWalletModal(true);
                                    setIsSidebarOpen(false);
                                }}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => e.key === 'Enter' && setShowWalletModal(true)}
                            >
                                <Wallet size={16} />
                                <span className="dashboard-sidebar__info-label">Saldo</span>
                                <span className="dashboard-sidebar__info-value">
                                    R$ {((wallet?.balance ?? 0) - (wallet?.reserved ?? 0)).toFixed(2)}
                                </span>
                            </div>
                        </div>

                        <nav className="dashboard-sidebar__nav">
                            {mobileMenuItems.map((item) => {
                                const Icon = item.icon;
                                const isActive = activeTab === item.id;
                                return (
                                    <button
                                        key={item.id}
                                        className={`dashboard-sidebar__nav-item ${isActive ? 'dashboard-sidebar__nav-item--active' : ''}`}
                                        onClick={() => handleTabClick(item.id)}
                                    >
                                        <Icon size={20} />
                                        <span className="dashboard-sidebar__nav-label">{item.label}</span>
                                        {item.badge > 0 && (
                                            <span className="dashboard-sidebar__nav-badge">{item.badge}</span>
                                        )}
                                    </button>
                                );
                            })}

                            {/* Configurações junto com o resto, mesmo estilo simples por enquanto */}
                            <button
                                className="dashboard-sidebar__nav-item"
                                onClick={() => {
                                    setShowProfileModal(true);
                                    setIsSidebarOpen(false);
                                }}
                            >
                                <UserCog size={20} />
                                <span className="dashboard-sidebar__nav-label">Configurações</span>
                            </button>
                        </nav>
                    </aside>

                    {/* Overlay */}
                    {isSidebarOpen && (
                        <div className="dashboard-sidebar__overlay" onClick={toggleSidebar} />
                    )}
                </div>
            )}

            {/* Conteúdo */}
            <main className="dashboard-content">
                {user && (
                    <DocumentStatusAlert
                        documentStatus={user.documentStatus}
                        documentUrlFront={user.documentUrlFront}
                        documentRejectionReason={user.documentRejectionReason}
                        onOpenProfile={() => setShowProfileModal(true)}
                    />
                )}

                {/* ── Aviso de CEP faltando, só no feed de vagas ── */}
                {user && activeTab === "vagas" && !hasValidCep && (
                    <div className="dashboard-cep-alert">
                        <p className="dashboard-cep-alert__text">
                            ⚠️ Você ainda não cadastrou seu CEP. Sem ele, as vagas próximas não aparecem pra você.
                        </p>

                        {!showCepForm ? (
                            <button
                                type="button"
                                className="dashboard-cep-alert__link"
                                onClick={() => setShowCepForm(true)}
                            >
                                Preencher CEP agora
                            </button>
                        ) : (
                            <div className="dashboard-cep-alert__form">
                                <div className="dashboard-cep-alert__field">
                                    <label className="dashboard-cep-alert__label">CEP</label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={9}
                                        placeholder="00000-000"
                                        value={cepForm.cep}
                                        onChange={(e) => {
                                            const cep = formatarCEP(e.target.value);
                                            setCepForm(prev => ({ ...prev, cep }));
                                            if (cep.replace(/\D/g, '').length === 8) {
                                                buscarCepFreelancer(cep);
                                            }
                                        }}
                                    />
                                    <p className="dashboard-cep-alert__hint">
                                        {loadingCep ? 'Buscando endereço...' : 'Digite o CEP para preencher o resto automaticamente.'}
                                    </p>
                                </div>

                                {cepForm.logradouro && (
                                    <p className="dashboard-cep-alert__hint">
                                        {cepForm.logradouro} — {cepForm.bairro}, {cepForm.cidade}/{cepForm.estado}
                                    </p>
                                )}

                                <div className="dashboard-cep-alert__grid">
                                    <div className="dashboard-cep-alert__field">
                                        <label className="dashboard-cep-alert__label">Número</label>
                                        <input
                                            value={cepForm.numero}
                                            onChange={(e) => setCepForm(prev => ({ ...prev, numero: e.target.value }))}
                                            placeholder="Ex: 123"
                                        />
                                    </div>
                                    <div className="dashboard-cep-alert__field">
                                        <label className="dashboard-cep-alert__label">Complemento</label>
                                        <input
                                            value={cepForm.complemento}
                                            onChange={(e) => setCepForm(prev => ({ ...prev, complemento: e.target.value }))}
                                            placeholder="Ex: Apto 45"
                                        />
                                    </div>
                                </div>

                                <div className="dashboard-cep-alert__actions">
                                    <button
                                        type="button"
                                        className="dashboard-cep-alert__btn dashboard-cep-alert__btn--outline"
                                        onClick={() => setShowCepForm(false)}
                                        disabled={savingCep}
                                    >
                                        Cancelar
                                    </button>
                                    <button
                                        type="button"
                                        className="dashboard-cep-alert__btn dashboard-cep-alert__btn--primary"
                                        onClick={handleSaveCep}
                                        disabled={savingCep}
                                    >
                                        {savingCep ? 'Salvando...' : 'Salvar CEP'}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {renderContent()}
            </main>
            {showProfileModal && (
                <ProfileModal
                    open={showProfileModal}
                    user={user}
                    atualizarPerfil={handleUpdateProfile}
                    onClose={() => setShowProfileModal(false)}
                    onAvatarUpdate={handleAvatarUpdate}
                    toast={({ title, description, variant }) => {
                        alert(`${title}: ${description}`);
                    }}
                />
            )}

            {user && (
                <ChatSupportButton
                    userId={user.id}
                    userType={user.userType}
                />
            )}

            <GoldWidget />

            {showGoldOnboarding && (
                <GoldOnboardingModal
                    onClose={() => setShowGoldOnboarding(false)}
                />
            )}

            {isGoldModalOpen && (
                <GoldModal
                    onClose={() => setIsGoldModalOpen(false)}
                />
            )}
            <WalletModal
                isOpen={showWalletModal}
                onClose={() => setShowWalletModal(false)}
                userData={user}
            />

            <InstallPwaBanner />
        </div>
    );
}